export default {
  title: `Whoops!
          <br /> Something Isn't Right`,
  description: `<p>Something went wrong.</p>
                <p>
                  Please try again later. If the problem persists, contact our
                  support team for assistance.
                </p>`,
};
